import { Navigate, useNavigate } from 'react-router';
import { useAcceptTerms, useTocAcceptance } from '@/hooks/useTocAcceptance';
import { TermsOfUseContent } from '@/components/TermsOfUseContent';
import { Button } from '@/components/Button';
import { PageSpinner } from '@/components/PageSpinner';

/** Port of toc-acceptance.page.ts / toc-acceptance.page.html. */
export default function TocAcceptancePage() {
  const navigate = useNavigate();
  const { hasAccepted, isPending } = useTocAcceptance();
  const acceptTerms = useAcceptTerms();

  if (isPending) return <PageSpinner message="Loading terms..." />;

  // Already accepted, so nothing to do here. <Navigate> rather than calling
  // navigate() here: navigating during render is a side effect React Router
  // warns about, and strict mode renders twice to surface exactly that.
  if (hasAccepted) return <Navigate to="/home" replace />;

  return (
    <div className="mx-auto max-w-3xl px-4 py-6">
      <TermsOfUseContent id="termsOfUse" />

      {acceptTerms.isError && (
        <p role="alert" className="mt-4 text-center text-money-negative">
          Your acceptance was not saved. Check your connection and try again.
        </p>
      )}

      <div className="mt-6 flex justify-center">
        <Button
          disabled={acceptTerms.isPending}
          onClick={() => acceptTerms.mutate(undefined, { onSuccess: () => navigate('/home') })}
        >
          {acceptTerms.isPending ? 'Saving...' : 'I agree to the Website Terms of Use'}
        </Button>
      </div>
    </div>
  );
}
